import React, { useEffect, useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import LoginForm from '../components/LoginForm';
import './DashboardVeille.css';
import { clearAuth, getAuthRole, setAuthRole, subscribeAuthRole } from '../utils/auth';

// Force le chargement depuis le serveur principal.
// On garde le même protocole que la page (http/https) pour éviter les erreurs "mixed content".
const VEILLE_URL = 'https://villa-santeodoro.com/veille.html';

const DashboardVeille = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return getAuthRole() === 'admin';
  });
  const [iframeHeight, setIframeHeight] = useState('100vh');

  useEffect(() => {
    return subscribeAuthRole((role) => {
      setIsAuthenticated(role === 'admin');
    });
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;

    const updateHeight = () => {
      const topbar = document.querySelector('.global-admin-topbar');
      const topbarHeight = topbar?.offsetHeight || 0;
      setIframeHeight(`${window.innerHeight - topbarHeight}px`);
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, [isAuthenticated]);

  const handleLogin = (role) => {
    if (role !== 'admin') {
      return;
    }
    setAuthRole('admin');
  };

  const handleLogout = () => {
    clearAuth();
  };

  if (!isAuthenticated) {
    return <LoginForm onLogin={handleLogin} />;
  }

  return (
    <div className="site-shell admin-shell">
      <AdminSidebar
        onLogout={handleLogout}
        sitePath="/it/affitto-villa-appartamento-sardegna-san-teodoro"
        role="admin"
      />
      <main className="admin-veille-main">
        <iframe
          title="Veille"
          className="admin-veille-iframe"
          src={VEILLE_URL}
          style={{ height: iframeHeight }}
        />
      </main>
    </div>
  );
};

export default DashboardVeille;
